import React, { useEffect, useState } from 'react';
import { convert } from 'html-to-text';

import {
  Container, Typography, Box, CircularProgress, Button,
  TextField, IconButton, Modal, Box as MuiBox,
  Switch, FormControlLabel,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,Tooltip
} from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Autocomplete } from '@mui/material';
import { Link } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ExpandLess, ExpandMore, Edit, Delete } from '@mui/icons-material';
import TablePagination from '@mui/material/TablePagination';
import ShareIcon from '@mui/icons-material/Share';
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';

const Opportunity = () => {

  const [options, setOptions] = useState({
      industries: [],
      companies: [],
      roles: [],
    });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [isProvider, setIsProvider] = useState(localStorage.getItem('isprovider') === 'yes');
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [openFormModal, setOpenFormModal] = useState(false);
  const [openApplyModal, setOpenApplyModal] = useState(false);

  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [editingOpportunity, setEditingOpportunity] = useState(null);

  const [expandedRow, setExpandedRow] = useState(null);
  const [applications, setApplications] = useState({});
  const [loadingApplications, setLoadingApplications] = useState({});

  const [openViewModal, setOpenViewModal] = useState(false);
  const [viewOpportunity, setViewOpportunity] = useState(null);

  const [isAdmin, setIsAdmin] = useState(null); 
  const handleViewClick = (opportunity) => {
    setViewOpportunity(opportunity);
    setOpenViewModal(true);
  };

  const handleViewClose = () => {
    setOpenViewModal(false);
    setViewOpportunity(null);
  };

  const [opportunityForm, setOpportunityForm] = useState({
    industry: '',
    company: '',
    role: '',
    comments: '',
    link: '',
    isActive: true,
  });

  const [applyForm, setApplyForm] = useState({ 
    profileSummary: '',
    resumeFile: null,
  });

  const [applyError, setApplyError] = useState('');
  const token = localStorage.getItem('token');


   useEffect(() => {
      
      
    }, []);


  useEffect(() => {
    fetchOpportunities();
    validateAdmin();
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/profile/options`)
          .then(res => setOptions(res.data))
          .catch(err => console.error('Error fetching options:', err));
  }, []);
  const validateAdmin = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsAdmin(false);
      return;
    }

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/validateAdmin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setIsAdmin(true);
    } catch (err) {
      console.error('Admin validation failed:', err);
      setIsAdmin(false);
    }
  };  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oppNum = params.get('opportunity_number');
    if (oppNum) {
      const foundOpp = opportunities.find(o => o.opportunity_number === parseInt(oppNum));
      if (foundOpp) {
        handleApplyClick(foundOpp);
      }
    }
  }, [opportunities]);

  const fetchOpportunities = () => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities`,{
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        const mapped = res.data.map(row => ({
          ...row,
          isActive: row.isActive === true || row.isActive === 'true' || row.isActive === 1 || row.isActive === '1',
        }));
        setOpportunities(mapped);
      })
      .catch(err => console.error('Error fetching opportunities', err))
      .finally(() => setLoading(false));
  };

  const fetchApplications = (opportunity_number) => {
    setLoadingApplications(prev => ({ ...prev, [opportunity_number]: true }));
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications?opportunity_number=${opportunity_number}`)
      .then(res => {
        setApplications(prev => ({ ...prev, [opportunity_number]: res.data }));
      })
      .catch(err => {
        console.error('Error fetching applications for opportunity:', opportunity_number, err);
        setApplications(prev => ({ ...prev, [opportunity_number]: [] }));
      })
      .finally(() => {
        setLoadingApplications(prev => ({ ...prev, [opportunity_number]: false }));
      });
  };

  const handleAddClick = () => {
    setEditingOpportunity(null);
    setOpportunityForm({ industry: '', company: '', role: '', comments: '', link: '', isActive: true });
    setOpenFormModal(true);
  };

  const handleEditClick = (opportunity) => {
    setEditingOpportunity(opportunity);
    setOpportunityForm({
      industry: opportunity.industry || '',
      company: opportunity.company || '',
      role: opportunity.role || '',
      comments: opportunity.comments || '',
      link: opportunity.link || '',
      isActive: opportunity.isActive === 1 || opportunity.isActive === true,
    });
    setOpenFormModal(true);
  };

  const handleDelete = (id) => {
    axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(() => fetchOpportunities())
      .catch(err => console.error('Error deleting opportunity', err));
  };

  const handleFormSubmit = () => {
    const url = editingOpportunity
      ? `${process.env.REACT_APP_API_BASE_URL}/api/opportunities/${editingOpportunity.id}`
      : `${process.env.REACT_APP_API_BASE_URL}/api/opportunities`;

    const method = editingOpportunity ? 'put' : 'post';

    axios[method](url, opportunityForm, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(() => {
        fetchOpportunities();
        setOpenFormModal(false);
      })
      .catch(err => console.error('Error submitting opportunity', err));
  };

  const handleApplyClick = (opportunity) => {
    setSelectedOpportunity(opportunity);
    setApplyForm({
      profileSummary: '',
      resumeFile: null,
    });
    setApplyError('');
    setOpenApplyModal(true);

    // Update URL param for direct link
    const url = new URL(window.location);
    url.searchParams.set('opportunity_number', opportunity.opportunity_number);
    window.history.replaceState(null, '', url.toString());
  };

  const handleApplyClose = () => {
    setOpenApplyModal(false);
    setSelectedOpportunity(null);
    setApplyForm({
      profileSummary: '',
      resumeFile: null,
    });

    // Clean URL param on close
    const url = new URL(window.location);
    url.searchParams.delete('opportunity_number');
    window.history.replaceState(null, '', url.toString());
  };

  const handleApplySubmit = () => {
    setApplyError('');
    if (!applyForm.profileSummary) {
      setApplyError('Please fill all required fields.');
      return;
    }
    if (!applyForm.resumeFile) {
      setApplyError('Please upload your resume.');
      return;
    }
    const formData = new FormData();
    formData.append('opportunity_number', selectedOpportunity.opportunity_number); 
    formData.append('profileSummary', applyForm.profileSummary);
    formData.append('resume', applyForm.resumeFile);

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
         Authorization: `Bearer ${token}`,
      },
    })
      .then(() => {
        alert('Application submitted successfully!'); 
        handleApplyClose();
        fetchOpportunities()
      })
      .catch(err => {
        console.error('Error submitting application:', err);
        setApplyError('Failed to submit application. Please try again.');
      });
  };

  const toggleExpandRow = (opportunity_number) => {
  if (expandedRow === opportunity_number) {
    // Collapse if already expanded
    setExpandedRow(null);
  } else {
    setExpandedRow(opportunity_number);
    if (applications[opportunity_number]) {
      const updatedApplications = { ...applications };
      delete updatedApplications[opportunity_number];
      setApplications(updatedApplications);
    }
    fetchApplications(opportunity_number);
  }
};
  const filteredOpportunities = opportunities.filter(opp =>
    opp.industry.toLowerCase().includes(filter.toLowerCase()) ||
    opp.company.toLowerCase().includes(filter.toLowerCase()) ||
    opp.role.toLowerCase().includes(filter.toLowerCase())||
    opp.opportunity_number==filter
  );

  const columns = [
    {
      field: 'expand',
      headerName: '',
      width: 50,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const oppNum = params.row?.opportunity_number;
        if (!oppNum) return null;
        return (
          <IconButton size="small" onClick={() => toggleExpandRow(oppNum)}>
            {expandedRow ? <ExpandLess  /> : <ExpandMore  />}
          </IconButton>
        );
      }
    },
    {
      field: 'apply',
      headerName: '',
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Button variant="outlined" size="small" onClick={() => handleApplyClick(params.row)}>
          Apply
        </Button>
      ),
    },
    { field: 'industry', headerName: 'Industry', width: 130 },
    { field: 'company', headerName: 'Company', width: 170 },
    { field: 'role', headerName: 'Role', width: 150 },
    { field: 'link', headerName: 'Link', width: 180 },
    { field: 'comments', headerName: 'Comments', width: 180 },
    {
      field: 'isActive',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => (params.row?.isActive ? 'Active' : 'Inactive'),
    }
  ];

  if (isProvider) {
    columns.push({
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEditClick(params.row)}>
            <EditIcon />
          </IconButton>
          <IconButton color="error" onClick={() => handleDelete(params.row.id)}>
            <DeleteIcon />
          </IconButton>
        </>
      ),
    });
  }
return (
  <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
  <Typography variant="h4" gutterBottom>
  Opportunities
  </Typography>
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      justifyContent: 'space-between',
      gap: 2,
      mb: 2,
    }}>
      <TextField
        label="Filter by Number or Industry or Company or Role"
        value={filter}
        onChange={e => setFilter(e.target.value)}
        fullWidth
      />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: { xs: 'center', sm: 'flex-end' } }}>
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={fetchOpportunities}
          sx={{ mr: 2 }}
        >
          Refresh
        </Button>
        {(
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
          >
            Add Opportunity
          </Button>
        )}
      </Box>
    </Box>

    {loading ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress />
      </Box>
    ) : (
      <>
        <div>
          <Box sx={{
              overflowX: 'auto',
              '& table': {
                minWidth: 900,
                borderCollapse: 'separate',
                borderSpacing: '0',
              },
              '& th, & td': {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                maxWidth: 200,
                fontSize: { xs: '12px', sm: '14px' },
                textAlign: 'left',
                padding: '8px',
              },
              '& thead th': {
                backgroundColor: '#f5f5f5',
                fontWeight: 600,
              },
              '& .MuiTablePagination-toolbar': {
                flexWrap: 'wrap',
                justifyContent: 'center',
              },
            }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    {isProvider&&<TableCell />}
                    <TableCell>View</TableCell>
                    <TableCell>Apply</TableCell>
                    <TableCell>Number</TableCell>
                    <TableCell>Industry</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Role</TableCell>
                    <TableCell>Link</TableCell>
                    <TableCell>Comments</TableCell>
                    <TableCell>Applications</TableCell>
                    <TableCell>Status</TableCell>   
                    {<TableCell>Actions</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredOpportunities.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(opportunity => (
                    <React.Fragment key={opportunity.id}>
                      <TableRow key={opportunity.id} sx={{ height: '48px' }}>
                        {isProvider&& <TableCell>
                          <IconButton onClick={() => toggleExpandRow(opportunity.opportunity_number)}>
                            {expandedRow === opportunity.opportunity_number ? <ExpandLess /> : <ExpandMore />}
                          </IconButton>
                        </TableCell>} 
                        <TableCell>
                        <Tooltip title="View Details">
                            <IconButton onClick={() => handleViewClick(opportunity)} color="info">
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Tooltip title={!opportunity.allow_apply ? "Already Applied":"Apply"}>
                            <IconButton disabled={!opportunity.allow_apply} onClick={() => handleApplyClick(opportunity)} color="primary">
                              <SendIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{opportunity.opportunity_number}</TableCell>                      
                        <TableCell>{opportunity.industry}</TableCell>
                        <TableCell>{opportunity.company}</TableCell>
                        <TableCell>{opportunity.role}</TableCell>
                        <TableCell>{opportunity.link}</TableCell>                    
                        <TableCell>
                          <Tooltip
                            title={
                              <div dangerouslySetInnerHTML={{ __html: opportunity.comments }} />
                            }
                            placement="top"
                            arrow
                          >
                            <span
                              style={{
                                display: 'inline-block',
                                maxWidth: 150,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                verticalAlign: 'middle',
                              }}
                            >
                              {convert(opportunity.comments || '', {
                                wordwrap: false,
                                limits: { maxInputLength: 100 },
                              })
                                .split(' ')
                                .slice(0, 3)
                                .join(' ') + '...'}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{opportunity.noapplications}</TableCell>
                        <TableCell>{opportunity.isActive ? 'Active' : 'Inactive'}</TableCell> 
                        <TableCell sx={{
                                          minWidth: 150,
                                          whiteSpace: 'nowrap',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 1, // optional spacing
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                        }}>
                            <IconButton disabled={!opportunity.allow_edit && !isAdmin} onClick={() => handleEditClick(opportunity)} color="primary">
                              <Edit />
                            </IconButton>
                            <IconButton disabled={!opportunity.allow_edit && !isAdmin} onClick={() => handleDelete(opportunity.id)} color="error">
                              <Delete />
                            </IconButton>
                            <Tooltip title="Copy Shareable Link"> 
                            <IconButton
                            onClick={() => {
                              const shareUrl = `${window.location.origin}${window.location.pathname}?opportunity_number=${opportunity.opportunity_number}`;
                              navigator.clipboard.writeText(shareUrl);
                              alert('Opportunity link copied to clipboard!');
                            }}
                          >
                            <ShareIcon />
                            </IconButton>
                            </Tooltip>
                          </TableCell>
                      </TableRow>

                      {/* Collapsible row */}
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={isProvider ? 10 : 9}>
                          <Collapse in={expandedRow === opportunity.opportunity_number} timeout="auto" unmountOnExit>
                            <Box sx={{
                                    mb: 2,
                                    p: 2,
                                    border: '1px solid #ccc',
                                    borderRadius: 1,
                                    bgcolor: 'white',
                                    fontSize: { xs: 12, sm: 14 },
                                    overflowWrap: 'break-word',
                                  }}>
                              {/* gutterBottom */}
                              <Typography variant="h6"   fontSize={{ xs: 16, sm: 20 }}>
                                Applications for Opportunity #{opportunity.opportunity_number}
                              </Typography>

                              {loadingApplications[opportunity.opportunity_number] ? (
                                <CircularProgress />
                              ) : (
                                <>
                                  {applications[opportunity.opportunity_number]?.length > 0 ? (
                                    applications[opportunity.opportunity_number].map(app => (
                                      <Box
                                        key={app.id}
                                        sx={{
                                          mb: 2,
                                          p: 2,
                                          border: '1px solid #ccc',
                                          borderRadius: 1,
                                          bgcolor: 'white',
                                          fontSize: { xs: 12, sm: 14 },
                                        }}
                                      > 
                                        <Typography><strong>Name:</strong> {app.name}</Typography>
                                        <Typography><strong>Mobile:</strong> {app.mobile}</Typography>
                                        <Typography><strong>Email:</strong> {app.email}</Typography>
                                        <Typography><strong>Profile Summary:</strong> {app.profile_summary}</Typography>
                                        {app.resume_filename ? (
                                          <Typography sx={{ mt: 1 }}>
                                            <strong>Resume:</strong>{' '}
                                            <Link
                                              href={`${process.env.REACT_APP_API_BASE_URL}/api/opportunities/applications/${app.id}/resume`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              underline="hover"
                                            >
                                              {app.resume_filename}
                                            </Link>
                                          </Typography>
                                        ) : (
                                          <Typography sx={{ mt: 1 }}>No Resume Uploaded</Typography>
                                        )}
                                      </Box>
                                    ))
                                  ) : (
                                    <Typography>No applications yet.</Typography>
                                  )}
                                </>

                              )}
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={filteredOpportunities.length}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Box>
        </div>
      </>
    )}

    {/* Add/Edit Opportunity Modal */}
    <Modal open={openFormModal} onClose={() => setOpenFormModal(false)}>
      <MuiBox
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 2,
            width: { xs: '90vw', sm: 400 },
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
      >
        <Typography variant="h6" gutterBottom>
          {editingOpportunity ? 'Edit Opportunity' : 'Add Opportunity'}
        </Typography>

        <Autocomplete
          freeSolo
          fullWidth
          options={options.industries}
          value={opportunityForm.industry}
          onChange={(e, newVal) => setOpportunityForm(prev => ({ ...prev, industry: newVal || '' }))}
          onInputChange={(e, newInputValue) => {
            setOpportunityForm(prev => ({ ...prev, industry: newInputValue }));
          }}
          renderInput={(params) => <TextField {...params} label="Industry" margin="normal" />}
        />
        <Autocomplete
          freeSolo
          fullWidth
          options={options.companies}
          value={opportunityForm.company}
          onChange={(e, newVal) => setOpportunityForm(prev => ({ ...prev, company: newVal || '' }))}
          onInputChange={(e, newInputValue) => {
            setOpportunityForm(prev => ({ ...prev, company: newInputValue }));
          }}
          renderInput={(params) => <TextField {...params} label="Company" margin="normal" />}
        />
        <Autocomplete
          freeSolo
          fullWidth
          options={options.roles}
          value={opportunityForm.role}
          onChange={(e, newVal) => setOpportunityForm(prev => ({ ...prev, role: newVal || '' }))}
          onInputChange={(e, newInputValue) => {
            setOpportunityForm(prev => ({ ...prev, role: newInputValue }));
          }}
          renderInput={(params) => <TextField {...params} label="Role" margin="normal" />}
        />
      <>
        <label
          htmlFor="job-description"
          style={{
            display: 'block',
            marginBottom: 4,
            fontSize: '0.875rem',
            fontWeight: 500,
            color: 'rgba(0, 0, 0, 0.6)', // Matches MUI's default label color
          }}
        >
          Job Description
        </label>
        <ReactQuill
          id="job-description"
          theme="snow"
          value={opportunityForm.comments}
          onChange={content =>
            setOpportunityForm(prev => ({ ...prev, comments: content }))
          }
          style={{
            height: 144, // ~6 rows
            overflowY: 'auto',
            borderRadius: 4,
            border: '1px solid rgba(0, 0, 0, 0.23)', // MUI-like border
            boxSizing: 'border-box',
            marginBottom: 16, // Like sx={{ mb: 2 }}
          }}
          modules={{
            toolbar: [
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['clean'],
            ],
          }}
        />
        </>
        {/* <TextField
          label="Job Description"
          fullWidth
          multiline
          value={opportunityForm.comments}
          rows={6}
          onChange={e => setOpportunityForm(prev => ({ ...prev, comments: e.target.value }))}
          sx={{ mb: 2, '& .MuiInputBase-root': {
      overflow: 'auto' // Enables scroll inside the textarea
        } }}
        /> */}
        <TextField
          label="Link"
          fullWidth
          value={opportunityForm.link}
          onChange={e => setOpportunityForm(prev => ({ ...prev, link: e.target.value }))}
          sx={{ mb: 2 }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={opportunityForm.isActive}
              onChange={e => setOpportunityForm(prev => ({ ...prev, isActive: e.target.checked }))}
            />
          }
          label="Active"
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => setOpenFormModal(false)} sx={{ mr: 1 }}>Cancel</Button>
          <Button variant="contained" onClick={handleFormSubmit}>
            {editingOpportunity ? 'Update' : 'Add'}
          </Button>
        </Box>
      </MuiBox>
    </Modal>

    {/* Apply Modal */}
    <Modal open={openApplyModal} onClose={handleApplyClose}>
      <MuiBox
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          p: 4,
          width: 400,
          borderRadius: 2,
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Apply for Opportunity #{selectedOpportunity?.opportunity_number} - {selectedOpportunity?.role}
        </Typography>
        <TextField
          label="Profile Summary"
          fullWidth
          multiline
          rows={3}
          value={applyForm.profileSummary}
          onChange={e => setApplyForm(prev => ({ ...prev, profileSummary: e.target.value }))}
          sx={{ mb: 2 }}
        />
        <Button variant="contained" component="label" sx={{ mb: 2 }}>
          Upload Resume
          <input
            type="file"
            hidden
            accept=".pdf,.doc,.docx"
            onChange={e => setApplyForm(prev => ({ ...prev, resumeFile: e.target.files[0] }))}
          />
        </Button>
        {applyForm.resumeFile && (
          <Typography variant="body2" sx={{ mb: 2 }}>
            Selected File: {applyForm.resumeFile.name}
          </Typography>
        )}
        {applyError && (
          <Typography color="error" sx={{ mb: 2 }}>
            {applyError}
          </Typography>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleApplyClose} sx={{ mr: 1 }}>Cancel</Button>
          <Button variant="contained" onClick={handleApplySubmit}>Submit</Button>
        </Box>
      </MuiBox>
    </Modal>

    {/* view model */}
    <Modal open={openViewModal} onClose={handleViewClose}>
    <MuiBox
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        p: 3,
        width: { xs: '90vw', sm: 500 },
        borderRadius: 2,
        boxShadow: 24,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Opportunity Details
      </Typography>
      {viewOpportunity && (
        <Box>
          <Typography><strong>Opportunity #:</strong> {viewOpportunity.opportunity_number}</Typography>
          <Typography><strong>Industry:</strong> {viewOpportunity.industry}</Typography>
          <Typography><strong>Company:</strong> {viewOpportunity.company}</Typography>
          <Typography><strong>Role:</strong> {viewOpportunity.role}</Typography>
          <Typography sx={{ mb: 2 }}><strong>Link:</strong> {viewOpportunity.link}</Typography>
          {/* <Typography><strong>Job Description:</strong> {viewOpportunity.comments}</Typography> */}
          <label
          htmlFor="job-description"
          style={{
            display: 'block',
            marginBottom: 4,
            fontSize: '0.875rem',
            fontWeight: 500,
            color: 'rgba(0, 0, 0, 0.6)', // Matches MUI's default label color
          }}
        >
          Job Description
        </label>
          <div
            style={{
              border: '1px solid rgba(0, 0, 0, 0.23)',
              borderRadius: 4,
              padding: 12,
              minHeight: 144,
              maxHeight: 144,
              overflowY: 'auto',
              marginBottom: 16,
              fontFamily: 'Roboto, sans-serif',
              fontSize: '0.875rem',
              color: 'rgba(0, 0, 0, 0.87)'
            }}
          > 
            <div dangerouslySetInnerHTML={{ __html: viewOpportunity.comments }} />
          </div>
          <Typography><strong>Status:</strong> {viewOpportunity.isActive ? 'Active' : 'Inactive'}</Typography>
        </Box>
      )}
      <Box textAlign="right" mt={2}>
        <Button onClick={handleViewClose}>Close</Button>
      </Box>
    </MuiBox>
  </Modal>
  </Container>
)
}
export default Opportunity;